import React, { useState } from 'react';
import Input from "../../form/Input";
import Textarea from "../../form/Textarea";
import Button from "../../form/Button";
import toastr from 'toastr';
import { postData } from '../../../services/api';
import { useTranslation } from "react-i18next";

const NewContactForm = () => {
    const { t } = useTranslation();
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [isSubmit, setIsSubmit] = useState(false);
    
    const handelSubmit = async () => {
        setIsSubmit(true);
        try {
            const result = await postData("/enquery/create", {
                name: name,
                phone: phone,
                email: email,
                subject: subject,
                message: message,
            });
            if (result.status === 200) {
                setSubject("");
                setMessage("");
                setEmail("");
                setName("");
                setPhone("");
                setIsSubmit(false);
                toastr.success(result.message)
            } else {
                toastr.error(result.message)
                setIsSubmit(false);
            }
        } catch (e) {
            toastr.error(e.message)
            setIsSubmit(false);
        }
    };
    
    return (
        <div className="py-10 lg:py-16 relative w-full bg-gradient-to-b from-slate-50 to-white">
            <div className="w-full max-w-[90%] xs:max-w-md sm:max-w-xl lg:max-w-5xl xl:max-w-6xl mx-auto space-y-10 lg:space-y-20">
                {/* Form Container with Card Style */}
                <div className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-100 p-6 sm:p-8 lg:p-10 xl:p-12">
                    <form>
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10">
                            {/* Left Column */}
                            <div className="w-full space-y-6">
                                <div className="relative group">
                                    <Input
                                        label={t('first_&_last_name')}
                                        inputPlaceholder="i.e. John Doe"
                                        labelClasses="capitalize font-PlusJakartaSans text-slate-900 !font-bold !text-base mb-2 flex items-center gap-2"
                                        inputClasses="bg-slate-50 hover:bg-slate-100 focus:bg-white border-2 border-slate-200 focus:border-dark-teal-500 transition-all duration-300 h-12 rounded-lg"
                                        inputValue={name}
                                        setInput={setName}
                                    />
                                    <div className="absolute right-3 top-[42px] text-slate-400 pointer-events-none">
                                        <i className="fa-light fa-user"></i>
                                    </div>
                                </div>
                                
                                <div className="relative group">
                                    <Input
                                        label={t('phone_number')}
                                        inputPlaceholder="i.e. +1-234-567-7890"
                                        labelClasses="capitalize font-PlusJakartaSans text-slate-900 !font-bold !text-base mb-2 flex items-center gap-2"
                                        inputClasses="bg-slate-50 hover:bg-slate-100 focus:bg-white border-2 border-slate-200 focus:border-dark-teal-500 transition-all duration-300 h-12 rounded-lg"
                                        inputValue={phone}
                                        setInput={setPhone}
                                    />
                                    <div className="absolute right-3 top-[42px] text-slate-400 pointer-events-none">
                                        <i className="fa-light fa-phone"></i>
                                    </div>
                                </div>
                                
                                <div className="relative group">
                                    <Input
                                        label={t('email')}
                                        inputPlaceholder="i.e. john@mail.com"
                                        labelClasses="capitalize font-PlusJakartaSans text-slate-900 !font-bold !text-base mb-2 flex items-center gap-2"
                                        inputClasses="bg-slate-50 hover:bg-slate-100 focus:bg-white border-2 border-slate-200 focus:border-dark-teal-500 transition-all duration-300 h-12 rounded-lg"
                                        inputValue={email}
                                        setInput={setEmail}
                                    />
                                    <div className="absolute right-3 top-[42px] text-slate-400 pointer-events-none">
                                        <i className="fa-light fa-envelope"></i>
                                    </div>
                                </div>
                            </div>
                            
                            {/* Right Column */}
                            <div className="w-full space-y-6">
                                <div className="relative group">
                                    <Input
                                        label={t('subject')}
                                        inputPlaceholder="i.e. I need a help"
                                        labelClasses="capitalize font-PlusJakartaSans text-slate-900 !font-bold !text-base mb-2 flex items-center gap-2"
                                        inputClasses="bg-slate-50 hover:bg-slate-100 focus:bg-white border-2 border-slate-200 focus:border-dark-teal-500 transition-all duration-300 h-12 rounded-lg"
                                        inputValue={subject}
                                        setInput={setSubject}
                                    />
                                    <div className="absolute right-3 top-[42px] text-slate-400 pointer-events-none">
                                        <i className="fa-light fa-lightbulb"></i>
                                    </div>
                                </div>
                                
                                <div className="relative group">
                                    <Textarea
                                        label={t('message')}
                                        labelClasses="capitalize font-PlusJakartaSans text-slate-900 !font-bold !text-base mb-2 flex items-center gap-2"
                                        inputPlaceholder="Type your message here..."
                                        inputClasses="bg-slate-50 hover:bg-slate-100 focus:bg-white border-2 border-slate-200 focus:border-dark-teal-500 transition-all duration-300 rounded-lg min-h-[140px] resize-y"
                                        inputValue={message}
                                        setTextarea={setMessage}
                                    />
                                    <div className="absolute right-3 top-[42px] text-slate-400 pointer-events-none">
                                        <i className="fa-light fa-message-lines"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        {/* Submit Button Section */}
                        <div className="flex flex-col sm:flex-row items-center justify-between mt-8 pt-6 border-t border-slate-200 gap-4">
                            <div className="text-sm text-slate-500 font-PlusJakartaSans">
                                <i className="fa-light fa-shield-check text-dark-teal-500 mr-2"></i>
                                Your information is safe with us
                            </div>
                            <div className="relative">
                                <Button
                                    buttonLabel={t('send_message')}
                                    buttonClasses="!bg-dark-teal-500 hover:!bg-dark-teal-600 !text-base xl:!text-lg lg:h-12 xl:h-14 !px-8 shadow-lg shadow-dark-teal-500/30 hover:shadow-xl hover:shadow-dark-teal-500/40 transition-all duration-300 rounded-lg"
                                    buttonLabelClasses="capitalize lg:!text-base xl:!text-lg tracking-wider !font-bold"
                                    buttonIconPosition="right"
                                    buttonIcon={
                                        isSubmit
                                            ? "fa-light fa-spinner fa-spin"
                                            : "fa-light fa-arrow-right"
                                    }
                                    functions={handelSubmit}
                                    buttonHasLink={false}
                                    buttonDisabled={isSubmit}
                                />
                            </div>
                        </div>
                    </form>
                </div>
                
                {/* Contact Info Cards Below Form */}
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                    <div className="bg-gradient-to-br from-dark-teal-500 to-dark-teal-600 rounded-xl p-6 text-white shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                        <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                            <i className="fa-solid fa-clock text-2xl"></i>
                        </div>
                        <h3 className="font-bold text-lg mb-2 font-PlusJakartaSans">Quick Response</h3>
                        <p className="text-sm text-white/80 font-PlusJakartaSans">We typically respond within 24 hours</p>
                    </div>
                    
                    <div className="bg-gradient-to-br from-slate-700 to-slate-800 rounded-xl p-6 text-white shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                        <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                            <i className="fa-solid fa-headset text-2xl"></i>
                        </div>
                        <h3 className="font-bold text-lg mb-2 font-PlusJakartaSans">24/7 Support</h3>
                        <p className="text-sm text-white/80 font-PlusJakartaSans">Our team is always here to help</p>
                    </div>
                    
                    <div className="bg-gradient-to-br from-dark-teal-500 to-dark-teal-600 rounded-xl p-6 text-white shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                        <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                            <i className="fa-solid fa-shield-check text-2xl"></i>
                        </div>
                        <h3 className="font-bold text-lg mb-2 font-PlusJakartaSans">Secure & Private</h3>
                        <p className="text-sm text-white/80 font-PlusJakartaSans">Your data is encrypted and protected</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewContactForm;